
import { PointInfo } from '../WalltoFittingInfo';
import { WallGrid } from './WallGrid';
import { Point, Picker } from "../graphicLibs/index";
import { ThreeView } from '../../view3d/webcad';
import * as THREE from 'three';
import { SmallWallDelete } from './modifier/index';

type resType = {
    gridList: number[][],
    pointIndexList: number[]
};

export class CreatePointData extends WallGrid {

    private copyCloseWiseData: number[][];
    public branchList: number[];
    public roomList: number[][];
    public outerWallList: number[];

    /** 頂点ステータスリスト */
    private statusList: number[]; // 0: 部屋, 1: 外周, 2:枝
    
    /** 外壁探索時に取得した枝候補リスト */
    private kouhoList: number[];

    constructor(public pointList: PointInfo[]) {
        /** しきい値 5mm 以内の壁は、壁としてあり得ないので削除して計算する */
        const smallWall = new SmallWallDelete(pointList);
        smallWall.length(5);
        pointList = smallWall.execute();

        super(pointList);

        this.branchList = [];
        this.roomList = [];
        this.outerWallList = [];

        this.statusList = new Array(pointList.length).fill(null);

        this.kouhoList = [];

        this.pointList = pointList;
    }

    /**
     * 
     * */
    public execute() {
        /** Gridリストコピー 削除対象は省く */
        this.copyCloseWiseData = this.clockwiseData.map((val: number[]) => {
            let array = val.map((i: number) => {
                if (this.pointList[i].isDelete == true) return null;
                return i;
            });
            array = array.filter((v: number) => v != null);
            if (array.length < 1) return null;
            return array;
        });

        /** 枝取得 */
        const obj: resType = this.branch(this.copyCloseWiseData);
        this.branchList = obj.pointIndexList;
        this.copyCloseWiseData = obj.gridList;
        
        /** 外周取得 */
        this.outerWall();
        
        /** 部屋取得 */
        this.room();

        /** 枝候補リストが部屋リストに含まれていなかったら枝壁とする */
        const room: number[] = this.roomList.map((indexes: number[]) => indexes.map((i: number) => i)).flat(); 
        this.kouhoList.filter((i: number) => {
            if (room.includes(i) == false) {
                this.branchList.push(i);
            } else {
                /** 頂点ステータスリスト */
                this.statusList[i] = 0;
            }
        });

        this.branchList = this.branchList.filter((index: number) => {
            if (room.includes(index) || room.includes(Point.nextPoint(index))) return false;
            return true;
        });

        /** 壁の頂点がどちらとも外周になっていたら、枝壁とする */
        for (let i = 0; i < this.statusList.length; i+=2) {
            if (this.statusList[i] == 1 && this.statusList[i+1] == 1) {
                this.branchList.push(i);
                this.branchList.push(i+1);
                this.statusList[i] = 2;
                this.statusList[i+1] = 2;
            }
        }

        // 
        this.branchList = this.branchList.filter((value, index) => {
            return index === this.branchList.indexOf(value);
        });

        //
        // console.log(this.statusList);
        
    }
    
    /**
     * 枝取得
     * */
    public branch(gridList: number[][], statusUpdate: boolean = true): resType {

        const branchList: number[] = [];
        
        const search = (): void => {

            /** 削除リスト */
            const deleteList: number[] = [];
            gridList.forEach((value: number[], index: number) => {
                if (value?.length == 1) deleteList.push(index);
            });
            if (deleteList.length == 0) return;

            for (let i = 0; i < deleteList.length; i++) {
                /** もう削除されている場合 */
                if (gridList[deleteList[i]] == null) continue;
                const index = gridList[deleteList[i]][0];
                const next = Point.nextPoint(index);
                branchList.push(...[index, next]);

                /** 頂点ステータスリスト */
                if (statusUpdate) {
                    this.statusList[index] = 2;
                    this.statusList[next] = 2;
                }

                // this.view(index, 0xff0000);
                // this.view(next, 0xff0000);

                // @ts-ignore
                gridList[deleteList[i]] = null;
                const gridIndex = this.indexToGridList[next];
                if (gridList[gridIndex]) gridList[gridIndex] = gridList[gridIndex].filter((val: number) => next != val);
                // @ts-ignore
                if (gridList[gridIndex] && gridList[gridIndex].length == 0) gridList[gridIndex] = null;

            }

            search();
            return;

        }

        search();

        return {
            gridList: gridList,
            pointIndexList: branchList
        };

    }

    /**
     * 枝刈りのためのリスト管理
     * */
    private manageBranchList(index: number, gridIndex: number, copyClockWiseData: number[][]): number[][] {
        if (copyClockWiseData[gridIndex] != null) {
            const find_1 = copyClockWiseData[gridIndex].findIndex((val: number) => val == index);
            if (find_1 != -1) {
                copyClockWiseData[gridIndex].splice(find_1, 1);
                if (copyClockWiseData[gridIndex].length == 0) copyClockWiseData[gridIndex] = null;
            }
        }
        const next_ = Point.nextPoint(index);
        const gridIndex_ = this.indexToGridList[next_];
        if (copyClockWiseData[gridIndex_] != null) {
            const find_2 = copyClockWiseData[gridIndex_].findIndex((val: number) => val == next_);
            if (find_2 != -1) {
                copyClockWiseData[gridIndex_].splice(find_2, 1);
                if (copyClockWiseData[gridIndex_].length == 0) copyClockWiseData[gridIndex_] = null;
            }
        }

        return copyClockWiseData;
    }

    /**
     * 外周探索
     * */
    private searchOuterWall(copyClockWiseData_: number[][]): resType {

        const wallList: number[] = [];
        let isFinish = false;
        const createWallList = (l: number): void => {

            wallList.push(l);

            const next = Point.nextPoint(l);
            const gridIndex = this.indexToGridList[next];
            const startIndex = this.clockwiseData[gridIndex].findIndex((value) => value == next);
            let index;
            let count = 0;
            for (let i = startIndex; count < this.clockwiseData[gridIndex].length; i++) {
                index = this.clockwiseData[gridIndex][(i + 1) % this.clockwiseData[gridIndex].length];
                if (index == wallList[0]) {
                    isFinish = true;
                    break;
                }
                const find = this.copyCloseWiseData[gridIndex].findIndex((val: number) => val == index);
                if (find != -1) {
                    // this.view(this.copyCloseWiseData[gridIndex][find], 0x00ff00);
                    this.copyCloseWiseData[gridIndex].splice(find, 1);
                    if (this.copyCloseWiseData[gridIndex].length == 0) this.copyCloseWiseData[gridIndex] = null;

                    this.outerWallList.push(index);

                    /** 頂点ステータスリスト */
                    this.statusList[index] = 1;

                    /** 枝刈りのためのリスト管理 */
                    copyClockWiseData_ = this.manageBranchList(index, gridIndex, copyClockWiseData_);
                    
                    break;
                }

                count += 1;
            }

            if (isFinish) return;

            createWallList(index);

        }

        const maxZ = this.getMinColumn(this.copyCloseWiseData);
        const index = this.copyCloseWiseData[maxZ][0];
        this.outerWallList.push(index);
        /** 頂点ステータスリスト */
        this.statusList[index] = 1;
        // this.view(index, 0x00ff00);
        createWallList(index);
        this.copyCloseWiseData[maxZ].splice(0, 1);
        if (this.copyCloseWiseData[maxZ].length == 0) this.copyCloseWiseData[maxZ] = null;
        /** 枝刈りのためのリスト管理 */
        copyClockWiseData_ = this.manageBranchList(index, maxZ, copyClockWiseData_);

        const obj: resType = this.branch(copyClockWiseData_, false);
        copyClockWiseData_ = obj.gridList;
        obj.pointIndexList?.forEach((index: number) => {
            const gridIndex = this.indexToGridList[index];
            // this.view(index, 0x000000);
            /** 枝刈りのためのリスト管理 */
            copyClockWiseData_ = this.manageBranchList(index, gridIndex, copyClockWiseData_);
        });

        return {
            gridList: copyClockWiseData_,
            pointIndexList: obj.pointIndexList
        };

    }

    /**
     * 外周取得
     * */
    public outerWall(): void {
        /** 探索リストに頂点が残っていなかったら探索しない */
        if (this.copyCloseWiseData.some((val) => val != null) == false) return;

        // 外周判定 -> 枝刈り候補決め -> 外周判定、、
        let copyClockWiseData_ = this.copyCloseWiseData.map((val: number[]) => val?.map((i: number) => i));

        const obj: resType = this.searchOuterWall(copyClockWiseData_);
        this.kouhoList.push(...obj.pointIndexList);

        /** 外周の線上、もしくは領域内に頂点が存在している場合 */
        let isContinue = false;
        if (this.outerWallList.length > 0) {
            const points = this.outerWallList.map((index: number) => new THREE.Vector2(this.pointList[index].point.clone().x, this.pointList[index].point.clone().z));
            const indexList = this.pointList.map((info: PointInfo, index: number) => index);
            let targetList = indexList.filter((index: number) => !(this.outerWallList.includes(index) || this.outerWallList.includes(Point.nextPoint(index))) && this.pointList[index].isDelete == false);
            targetList = targetList.filter((index: number) => !this.branchList.includes(index) && this.pointList[index].isDelete == false);
            for (let i = 0; i < targetList.length; i++) {
                const p = this.pointList[targetList[i]].point.clone();
                // 内外判定
                const isCheck = new Picker()._Check(points, new THREE.Vector2(p.x, p.z));
                // 直線上の点
                const isCheckOnLine = this.isOnLine(points, new THREE.Vector2(p.x, p.z));
                /** 領域の外、かつ直線上にも存在しない */
                if (!(isCheck && isCheckOnLine)) {
                    /** 探索リストにまだ頂点が残っていたら */
                    if(isContinue && copyClockWiseData_.some((val) => val != null)) this.outerWall();
                    break;
                }
            }
        }

        return;
    }


    /**
     * x -> min y -> min (列が同じ場合、z方向がプラスのものを取る) 
     * */
    private getMinColumn(gridList: number[][]): number {

        let gridIndexes: number[];
        let minColumn = Infinity;
        const column = gridList.length / this.row;
        for (let j = 0; j < column; j++) {
            for (let i = 0; i < this.row; i++) {
            // console.log('i', i);
            
                // console.log('j', j);
                const gridIndex = Point.indexFromGridNumber(i, j, this.row);
                // console.log(gridIndex);
                
                if (gridList[gridIndex] == null) continue; 
                if (i == minColumn) {
                    gridIndexes.push(gridIndex);
                    continue;
                }
                if (i < minColumn) {
                    gridIndexes = [gridIndex];
                    minColumn = i;
                }
            }
        }
        const maxZ = Math.max(...gridIndexes);

        return maxZ;
    }

    /**
     * 部屋取得
     * */
    public room(): void {

        let oneRoomList: number[] = [];
        const createRoomList = (l: number): void => {
            let isFinish = true;

            oneRoomList.push(l);
            /** 頂点ステータスリスト */
            this.statusList[l] = 0;

            const next = Point.nextPoint(l);
            const gridIndex = this.indexToGridList[next];
            const startIndex = this.clockwiseData[gridIndex].findIndex((value) => value == next);
            let point;
            let count = 0;
            for (let i = startIndex; count < this.clockwiseData[gridIndex].length; i++) {
                point = this.clockwiseData[gridIndex][(i + 1 + this.clockwiseData[gridIndex].length) % this.clockwiseData[gridIndex].length];
                if (point == oneRoomList[0]) {
                    this.roomList.push(oneRoomList);
                    oneRoomList = [];
                    break;
                }
                const find = this.copyCloseWiseData[gridIndex] ? this.copyCloseWiseData[gridIndex].findIndex((val: number) => val == point) : -1;
                if (find != -1) {
                    isFinish = false;
                    // this.view(this.copyCloseWiseData[gridIndex][find], 0x0000ff);
                    this.copyCloseWiseData[gridIndex].splice(find, 1);
                    if (this.copyCloseWiseData[gridIndex].length == 0) this.copyCloseWiseData[gridIndex] = null;
                    break;
                }

                count += 1;
            }

            if(isFinish) {
                if (this.copyCloseWiseData.some((val: number[]) => val != null) == false) return; 
                const maxZ = this.getMinColumn(this.copyCloseWiseData);
                const index = this.copyCloseWiseData[maxZ][0];
                this.copyCloseWiseData[maxZ].splice(0, 1);
                if (this.copyCloseWiseData[maxZ].length == 0) this.copyCloseWiseData[maxZ] = null;
                createRoomList(index);
                return;
            }

            createRoomList(point);

        }

        /** 探索リストに頂点が残っていなかったら探索しない */
        if (this.copyCloseWiseData.some((val) => val != null) == false) return;
        
        // 最小値(grid 0)から時計回りに探索 zの最大gridとってくる
        const maxZ = this.getMinColumn(this.copyCloseWiseData);
        const index = this.copyCloseWiseData[maxZ][0];
        // this.view(index, 0x0000ff);
        this.copyCloseWiseData[maxZ].splice(0, 1);
        if (this.copyCloseWiseData[maxZ].length == 0) this.copyCloseWiseData[maxZ] = null;
        createRoomList(index);
        
    }

    private view(point: number, color) {
        const geometry = new THREE.SphereGeometry(0.1);
        const mesh = new THREE.Mesh(geometry, new THREE.MeshBasicMaterial({color: color}));
        mesh.position.set(this.pointList[point].point.x, 0, this.pointList[point].point.z);
        ThreeView.get().wcItemmgr.addLiDARShapes(mesh);
        mesh.userData = {index: point}
    }

    // 直線上の頂点はtrue
    private isOnLine(points: THREE.Vector2[], target: THREE.Vector2): boolean {
        for (let i = 0; i < points.length; i++) {
            const p1 = points[i];
            const p2 = points[(i + 1) % points.length];
            
            const dir = target.clone().sub(p1);
            const next = p2.clone().sub(p1);
            const length = dir.clone().dot(next) / (next.length());
            /** 垂直に下したときの線が線分上になかったら除外 */
            if (next.length() < length || length < 0) continue;

            const line = dir.clone().cross(next) / next.length();
            /** 直線上 */
            if (Math.abs(line) < 0.05) return true;
        }

        return false;
    }

}